import * as API from '@/api';
import DEFINES from '@/defines';
import {getField, updateField} from 'vuex-map-fields';
//initial state
function initialState () {
  return {
    list: [],
  };
}
const state = initialState ();

// actions

const actions = {
  async deployStage () {
    var response = await API.adminDashboard.deployStage ();
  },
  async getSummary (context, payload) {
    var response = await API.adminDashboard.getSummary (payload);
    return response;
  },
};

//getters

const getters = {
  getField,
};

// mutations
const mutations = {};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
